export default "__VITE_ASSET__C8bvATVA__";